import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import Charts from "../SummaryTab/Charts";
import Filtering from "../RuleCatalogue/Filtering";
import PivotTable from "../SummaryTab/PivotTable";
import heartLoading from "../../assests/heartLoading.gif";

const Summary = ({
  productId = null,
  currentFilters = {},
  onFiltersChange,
  searchTerm = "",
  onSearchChange,
  activePeriod,
  onPeriodChange,
}) => {
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [dqScores, setDqScores] = useState(null);

  const [pivotGrouping, setPivotGrouping] = useState({});

  const capitalize = (str) =>
    str.charAt(0).toUpperCase() + str.slice(1);

  useEffect(() => {
    if (Object.keys(pivotGrouping).length > 0) {
      onFiltersChange({ pivot_grouping: pivotGrouping });
    }
  }, [pivotGrouping, onFiltersChange]);


  const buildQueryString = () => {
    let query = [];

    query.push(`product_id=${productId}`);
    query.push(`page=${page}`);
    query.push(`page_size=${pageSize}`);
    query.push(`period=${activePeriod}`);

    Object.entries(currentFilters).forEach(([key, value]) => {
      if (!value) return;

      const mappedKey = capitalize(key); 

      if (Array.isArray(value)) {
        value.forEach((v) => {
          query.push(`filter=${mappedKey}=${v}`);
        });
      } else {
        query.push(`filter=${mappedKey}=${value}`);
      }
    });

    if (searchTerm) query.push(`search=${searchTerm}`);

    return query.join("&");
  };

  useEffect(() => {
    if (!productId) return;

    const fetchData = async () => {
      try {
        setLoading(true);

        const qs = buildQueryString();
        const url = `${BASE_URL}/product-overview?${qs}`;

        const res = await axios.get(url);

        setData(res.data);
        setDqScores(res.data.dqMetrics);
      } catch (err) {
        console.error("Error fetching summary:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [
    productId,
    currentFilters,
    searchTerm,
    page,
    pageSize,
    activePeriod,
    BASE_URL,
  ]);

  useEffect(() => {
    setPage(1);
  }, [searchTerm, currentFilters]);


  const handlePeriodChange = (period) => {
    onPeriodChange(period);
  };


  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setPage(1);
  };


  if (!data || (!dqScores && !data?.dqMetrics)) {
    return (
      <div className="relative bg-white flex items-center justify-center z-50 h-[80vh]">
        <div className="flex flex-col items-center space-y-3">
          <img src={heartLoading} alt="Loading..."  width={200} />
          <span className="text-gray-700 text-[20px] text-center">
            Hang tight! The resources are loading...
          </span>
        </div>
      </div>
    );
  }
  const excludedColumns = [
    "rule_name",
    "rule_phase",
    "rule_description",
    "total_row_count",
    "error_record_count",
    "validity",
    "accuracy",
    "consistency",
    "completeness",
    "freshness",
    "uniqueness"
  ];


  return (
    <div className="summary">

      <Filtering
        productId={productId}
        currentFilters={currentFilters}
        onFiltersChange={onFiltersChange}
        showPeriodToggle={true}
        activePeriod={activePeriod}
        onPeriodChange={handlePeriodChange}
        searchTerm={searchTerm}
        onSearchChange={onSearchChange}
      />

      {dqScores && (
        <Charts scores={dqScores} period={activePeriod} />
      )}

      <PivotTable
        tableData={data.tableData}
        paginationData={data.pagination}
        filterList={Object.keys(data.tableData?.[0] || {}).filter(
          key => !excludedColumns.includes(key)
        )}
        apiLoading={loading}
        onPageChange={setPage}
        onPageSizeChange={handlePageSizeChange}
        onGroupingChange={setPivotGrouping}
        pivotGrouping={currentFilters?.pivot_grouping || {}}
        productId={productId}
        currentFilters={currentFilters}
        page={page}
        searchTerm={searchTerm}
        activePeriod={activePeriod}
      />

    </div>
  );
};

export default Summary;
